<template>
	<div class="content">
		<div class="row animated fadeIn">
			<div class="col-md-12">
				<Alert :type="alertType" :message="alertMessage" v-if="alertShow === true" />
				<div class="card" v-if="asyncDone === false">
					<!-- Show the loader when async operation is going on -->
					<div class="loader"></div>
					<h4 style="text-align: justify;padding-left: 20px; padding-right: 20px">{{asyncText}}</h4>
				</div>
			</div>
			<div class="col-md-12" v-if="asyncDone === true">
				<div class="card">
					<div class="card-header">
						<h4 class="card-title d-inline-block">Site Details</h4>
						<router-link :to="{name: 'addSite'}" tag="button" type="button" class="btn btn-primary btn-round d-inline-block float-right">
							<i class="fa fa-plus"></i> Add Another Site
						</router-link>
					</div>
					<div class="card-body">
						<SiteList />
					</div>
				</div>
				<router-link :to="{name: 'addSite'}" tag="button" type="button" class="btn btn-primary btn-lg w-100">
					<i class="fa fa-plus"></i> Add Another Site
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: "siteDetails",
  components: {
    Alert: () =>
      import(/* webpackChunkName: "alert" */ "../../../../components/Alerts.vue"),
    SiteList: () =>
      import(/* webpackChunkName: "siteList" */ "../../../../components/User/Sites/SiteList.vue")
  },
  computed: {
    asyncDone() {
      return this.$store.getters["async/state"];
    },
	asyncText() {
		return this.$store.getters["async/text"];
	},
    alertType() {
      return this.$store.getters["alert/type"];
    },
    alertMessage() {
      return this.$store.getters["alert/message"];
    },
    alertShow() {
      return this.$store.getters["alert/show"];
		}
  }
};
</script>
